<template>
  <div id="app">
    <div is="sui-container">
      <sui-grid>
        <sui-grid-column :width="8" class="mb0">
          <h2 is="sui-header">
            <img src="@/assets/logo.png" alt>
            <sui-header-content>
              OBWan
              <sui-header-subheader>Management Console</sui-header-subheader>
            </sui-header-content>
          </h2>
        </sui-grid-column>
        <sui-grid-column :width="8" class="mb0">
          <div class="user-info" v-if="user">
            <div class="picture" :style="{ backgroundImage: `url(${user.picture})` }"></div>
            <div class="text">
              <div class="signed-in">Signed in as</div>
              <div class="email">{{ user.email }}</div>
            </div>
          </div>
        </sui-grid-column>
      </sui-grid>
      <sui-menu v-if="isLoggedIn" pointer>
        <router-link
          :to="'/'"
          is="sui-menu-item"
          :content="'Dashboard'"
          :active-class="'active'"
          exact
        />
        <sui-menu-menu position="right">
          <a is="sui-menu-item" content="Logout" @click="logout"/>
        </sui-menu-menu>
      </sui-menu>
      <router-view></router-view>
      <footer>Copyright © 2021 EMG Digital</footer>
    </div>
  </div>
</template>
<script>
import { getUserInfo, logout, isLoggedIn } from "./services/authentication";
export default {
  name: "App",
  mounted() {
    getUserInfo()
      .then((user) => {
        this.user = user;
      })
      .catch(error => {
        if (error === "userinfo") logout();
      });
  },
  data () {
    return {
      user: null
    }
  },
  computed: {
    isLoggedIn() {
      return isLoggedIn();
    }
  },
  methods: {
    logout() {
      logout();
    }
  }
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
h2 {
  margin-top: 0.6em !important;
  margin-bottom: 0.6em !important;
  .content {
    font-size: 20px;
    .sub.header {
      font-size: 12px !important;
    }
  }
  img {
    height: 30px !important;
    width: 45px !important;
    padding-top: 3px;
  }
}
.mb0 {
  padding-bottom: 0 !important;
}
.user-info {
  margin-top: 17px;
  height: 40px;
  .picture {
    height: 40px;
    width: 40px;
    background: grey;
    background-size: cover;
    background-position: center center;
    float: right;
    overflow: hidden;
    border-radius: 5px;
    
  }
  .text {
    text-align: right;
    float: right;
    margin-right: 15px;
    color: rgb(30, 30, 30);
    font-size: 13px;
    line-height: 15px;
    padding-top: 7px;
    .signed-in {
      color: rgb(110, 110, 110);
      font-size: 10px;
      font-style: oblique;
    }
  } 
}
footer {
  margin-top: 25px;
  margin-bottom: 25px;
  color: grey;
  font-style: oblique;
}
</style>